import { getAutomationSidebarPath } from '#pplx/frontend/apps/ask/queries/automation-queries/automationRunRoute.js';
import { useRouter } from '#pplx/frontend/router/provider.js';
import { useEffect } from 'react';
import { useRoute } from 'wouter';
export function AutomationLegacyRedirect() {
    const [, detailParams] = useRoute('/computer/automations/:automationId');
    const [, runParams] = useRoute('/computer/automations/:automationId/runs/:runId');
    const automationId = runParams?.automationId ?? detailParams?.automationId;
    const destination = automationId
        ? getAutomationSidebarPath(automationId)
        : '/computer/automations';
    const { replace } = useRouter();
    useEffect(() => {
        replace(destination);
    }, [destination, replace]);
    return null;
}
//# sourceMappingURL=AutomationLegacyRedirect.js.map